// extracted by mini-css-extract-plugin
export default {"contact_hero":"ContactHero_contact_hero__9504U","hero_header":"ContactHero_hero_header__EaKI3"};